<template>
	<section class="breadcrumbs">
		<div class="container">

			<slot name="breadcrumbs"></slot>

		</div>
	</section>
</template>

<script>
export default {
	data() {
		return {};
	},

	props: {},

	computed: {},

	watch: {},

	methods: {},

	components: {},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.breadcrumbs {
	display: block;
	position: relative;
	background: transparent;
	padding-top: 24px;
	width: 100%;

	.mixed_content & {
		margin-top: 0;
		padding-top: 0;
		margin-bottom: 30px;
	}

	.container {
		position: relative;
		z-index: 25;
		/* width: 100%; */

		#breadcrumbs {
			// position: relative;
			grid-column: span 12;
			/* min-height: 50px; */
			padding: 0;
			display: flex;
			flex-direction: row;
			justify-content: flex-start;
			align-items: center;

			.theme--blue & {
				border-bottom: 1px solid var(--midnight);
				padding-bottom: 24px;
			}

			.theme--dark_blue &,
			.theme--white &,
			.theme--none & {
				border-bottom: 1px solid var(--cobalt);
				padding-bottom: 24px;
			}

			@media (max-width: $mobile-xl) {
				grid-column: span 4;
			}

			.breadcrumb_container {
				> span {
					grid-column: span 12;
					display: inline-flex;
					font: normal normal normal 14px/20px var(--primary-font-family);
					text-transform: unset;
					align-items: center;
					flex-wrap: wrap;

					span {
						display: inline-flex;
						font: normal normal normal 14px/20px var(--primary-font-family);
						text-transform: unset;
						align-items: flex-start;
						text-indent: 0;

						@media only screen and (max-width: 768px) {
							&:first-child {
								text-indent: -9999px;
							}

							&:first-child::before {
								content: '…';
								text-indent: 0;

								.theme--blue &,
								.theme--dark_blue & {
									color: var(--white);
								}
							}
						}

						&.breadcrumb_last {
							color: var(--midnight);
							font: normal normal normal 14px/20px var(--primary-font-family);
							/* opacity: 0.7; */

							.theme--blue &,
							.theme--dark_blue & {
								color: var(--white);

								span,
								strong {
									color: var(--white);
									font-weight: bold;
								}
							}
						}

						a {
							font: normal normal normal 14px/20px var(--primary-font-family);
							text-transform: unset;
							color: var(--midnight);
							text-decoration: none;
							display: inline-flex;
							align-items: center;

							.theme--blue &,
							.theme--dark_blue & {
								color: var(--white);
							}
						}

						strong {
							font: normal normal normal 14px/20px var(--primary-font-family);
							text-transform: unset;
							color: var(--midnight);
							text-decoration: none;

							.theme--blue &,
							.theme--dark_blue & {
								color: var(--white);
							}
						}

						&.divider {
							margin: 0 15px;
							display: flex;
							justify-content: center;
							align-items: flex-start;

							&::before {
								// margin: 5px 10px 0 0;
								font: normal normal 500 11px/20px var(--primary-font-family);
								content: '';
								width: 4px;
								height: 4px;
								background: var(--midnight);
								border-radius: 50%;
								/* color: var(--midnight); */

								.theme--blue & {
									background: var(--white);
									color: var(--white);
								}

								.theme--dark_blue &,
								.theme--white &,
								.theme--none & {
									background: var(--cobalt);
									color: var(--cobalt);
								}
							}
						}

						&:last-child {
							a {
								font: normal normal normal 14px/20px var(--primary-font-family);
								text-transform: unset;
							}
						}
					}
				}
			}
		}
	}
}
</style>
